/* globals document */

import { useRef, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

const useSidecartFocus = (sidecartNode) => {
  const cartReducer = useSelector((state) => state.cart);
  const { isSideCartVisible, skuBeingAdded } = cartReducer;
  const exitButton = document.getElementById('c7-side-cart__header__close');
  const lastFocusedNodeRef = useRef(null);
  const proceedNode = document.getElementById('c7-side-cart__summary__proceed');

  if (sidecartNode) {
    sidecartNode.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        selectParentButton();
      }
    });
  }

  if (exitButton) {
    exitButton.onclick = function () {
      selectParentButton();
    };
  }

  const handleFocusIn = useCallback(() => {
    if (!sidecartNode?.contains(document.activeElement)) {
      lastFocusedNodeRef.current = document.activeElement;
    }
  }, [sidecartNode]);

  const selectParentButton = () => {
    setTimeout(() => {
      lastFocusedNodeRef?.current?.focus();
    }, 50);
  };

  const handleFocusOut = useCallback(() => {
    handleFocusLastNode();
  }, []);

  const handleFocusLastNode = () => {
    document.getElementById('c7-side-cart__header__close')?.focus();
  };

  const handleFocusCloseButton = () => {
    setTimeout(() => {
      document.getElementById('c7-side-cart__header__close')?.focus();
    }, 50);
  };

  useEffect(() => {
    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, [handleFocusIn]);

  useEffect(() => {
    proceedNode?.addEventListener('focusout', handleFocusOut);
    return () => {
      proceedNode?.removeEventListener('focusout', handleFocusOut);
    };
  }, [proceedNode, handleFocusOut]);

  useEffect(() => {
    if (isSideCartVisible) {
      handleFocusCloseButton();
    } else {
      handleFocusLastNode();
    }
  }, [isSideCartVisible, skuBeingAdded]);
};

export default useSidecartFocus;
